export default class NotSupportedError extends Error {
  static CODE = 'not-supported'

  constructor(message) {
    super(message)
    this.code = NotSupportedError.CODE
  }
}
